import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { 
  ArrowRight, Star, Truck, Gift, Shield, 
  Heart, Clock, CheckCircle, 
  Award, Phone, MapPin, ShoppingBag,
  Package, CreditCard, Headphones, Flower,
  Cake, Music,
  Users, ThumbsUp, Award as AwardIcon,
  MessageCircle, Instagram, Facebook,
  Twitter, PhoneCall, MapPin as MapPinIcon,
  ChevronLeft,
  ChevronRight
} from 'lucide-react';
import ProductCard from '../components/ProductCard';

const Home = () => {
  const [featuredProducts, setFeaturedProducts] = useState([]);
  const [featuredCombos, setFeaturedCombos] = useState([]);
  const [loading, setLoading] = useState(true);
  const productScrollRef = useRef(null);
  const comboScrollRef = useRef(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // const [productsRes, combosRes] = await Promise.all([
        //   fetch('/data/products.json'),
        //   fetch('/data/combos.json')
        // ]);
        


   const [productsRes, combosRes] = await Promise.all([
       fetch('https://server.sohkinflowergifts.com/api/products'),

          fetch('https://server.sohkinflowergifts.com/api/combos')
        ]);





        const productsData = await productsRes.json();

console.log(productsData)

        const combosData = await combosRes.json();
        
        setFeaturedProducts(productsData.products.slice(0, 10)); // Increased to 10
        setFeaturedCombos(combosData.combos.slice(0, 10));
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const scrollLeft = (ref) => {
    if (ref.current) {
      ref.current.scrollBy({ left: -300, behavior: 'smooth' });
    }
  };

  const scrollRight = (ref) => {
    if (ref.current) {
      ref.current.scrollBy({ left: 300, behavior: 'smooth' });
    }
  };

  if (loading) {
    return (
      <div className="flex flex-col justify-center items-center min-h-screen bg-gradient-to-b from-pink-50 to-white">
        <div className="relative">
          <div className="h-16 w-16 rounded-full border-t-4 border-b-4 border-pink-600 animate-spin"></div>
          <div className="absolute inset-0 flex items-center justify-center">
            <Flower className="h-8 w-8 text-pink-600 animate-pulse" />
          </div>
        </div>
        <p className="mt-4 text-base text-gray-600 font-medium">Loading beautiful blooms...</p>
      </div>
    );
  }

  const testimonials = [
    {
      id: 1,
      name: "Priya Sharma",
      location: "Mumbai",
      comment: "The birthday bouquet was stunning! Fresh flowers delivered on time.",
      rating: 5,
      image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80",
      occasion: "Birthday"
    },
    {
      id: 2,
      name: "Rahul Mehta",
      location: "Delhi",
      comment: "Perfect for corporate gifting. Professional and reliable!",
      rating: 4,
      image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80",
      occasion: "Corporate"
    },
    {
      id: 3,
      name: "Anjali Patel",
      location: "Bangalore",
      comment: "Anniversary combo was magical. Made our day special!",
      rating: 5,
      image: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80",
      occasion: "Anniversary"
    },
    {
      id: 4,
      name: "Suresh Kumar",
      location: "Chennai",
      comment: "Excellent service and quality. Will order again!",
      rating: 5,
      image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80",
      occasion: "Thank You"
    }
  ];

  const stats = [
    { number: "10K+", label: "Happy Customers", icon: Users, color: "text-pink-600", bgColor: "bg-pink-100" },
    { number: "50+", label: "Cities", icon: MapPin, color: "text-blue-600", bgColor: "bg-blue-100" },
    { number: "98%", label: "Positive Reviews", icon: ThumbsUp, color: "text-green-600", bgColor: "bg-green-100" },
    { number: "24/7", label: "Support", icon: Headphones, color: "text-purple-600", bgColor: "bg-purple-100" }
  ];

  const features = [
    {
      icon: Truck,
      title: "Free & Fast Delivery",
      description: "Free shipping on orders above ₹999. Same-day delivery available."
    },
    {
      icon: Shield,
      title: "Quality Guarantee",
      description: "Handpicked fresh flowers with freshness guarantee."
    },
    {
      icon: Gift,
      title: "Premium Service",
      description: "Free gift wrapping with personalized cards."
    },
    {
      icon: CreditCard,
      title: "Secure Payment",
      description: "100% secure with multiple payment options."
    }
  ];

  return (
    <div className="bg-gradient-to-b from-pink-50 via-white to-pink-50">
      {/* Hero Section - Compact */}
      <section className="relative overflow-hidden bg-gradient-to-r from-pink-600 via-purple-600 to-pink-800 text-white">
        <div className="absolute inset-0">
          <img 
            src="https://images.unsplash.com/photo-1490750967868-88aa4486c946?ixlib=rb-1.2.1&auto=format&fit=crop&w=1920&q=80"
            alt="Flower background"
            className="w-full h-full object-cover opacity-20"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-pink-700/90 via-purple-700/90 to-pink-900/90"></div>
        </div>
        
        <div className="container relative z-10 mx-auto px-4 py-12 md:py-16">
          <div className="flex flex-col items-center text-center">
            <div className="inline-flex items-center px-3 py-1 rounded-full bg-white/20 backdrop-blur-sm mb-4">
              <Award className="h-3.5 w-3.5 mr-1.5" />
              <span className="text-xs font-medium">India's Trusted Flower Delivery</span>
            </div>
            
            <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-4 leading-snug">
              Beautiful Flowers & 
              <span className="block text-pink-200">Gifts That Speak Love</span>
            </h1>
            
            <p className="text-sm sm:text-base md:text-lg mb-6 text-pink-100 max-w-2xl">
              Same-day delivery across 50+ cities. Fresh flowers, cakes, and gifts delivered with care.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-3 mb-6 w-full max-w-sm">
              <Link 
                to="/shop" 
                className="inline-flex items-center justify-center bg-white text-pink-700 px-6 py-3 rounded-full font-bold text-base hover:bg-pink-50 transition-all shadow-lg"
              >
                <ShoppingBag className="mr-2 h-5 w-5" />
                Shop Now
              </Link>
            </div>
            
            <div className="grid grid-cols-2 gap-3 max-w-xs">
              <div className="text-center bg-white/10 p-3 rounded-xl">
                <div className="text-lg sm:text-xl font-bold mb-1">24/7</div>
                <div className="text-xs text-pink-200">Delivery</div>
              </div>
              <div className="text-center bg-white/10 p-3 rounded-xl">
                <div className="text-lg sm:text-xl font-bold mb-1">100%</div>
                <div className="text-xs text-pink-200">Fresh</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section - Compact Grid */}
      <section className="py-8 sm:py-12">
        <div className="container mx-auto px-4">
          <div className="text-center mb-6">
            <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mb-2">
              Why Choose <span className="text-pink-600">Sohkin Flowers</span>
            </h2>
          </div>
          
          <div className="grid grid-cols-2 gap-3 sm:gap-4">
            {features.map((feature, index) => {
              const Icon = feature.icon;
              return (
                <div key={index} className="bg-white p-4 rounded-xl shadow-sm border border-gray-100">
                  <div className="inline-flex items-center justify-center w-10 h-10 rounded-full bg-pink-100 text-pink-600 mb-3">
                    <Icon className="h-5 w-5" />
                  </div>
                  <h3 className="text-sm font-bold mb-2">{feature.title}</h3>
                  <p className="text-xs text-gray-600">{feature.description}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Featured Products - Horizontal Scroll */}
      <section className="py-8">
        <div className="container mx-auto px-4">
          <div className="flex justify-between items-center mb-4">
            <div>
              <h2 className="text-lg sm:text-xl font-bold text-gray-900">Featured Products</h2>
              <p className="text-xs text-gray-600">Handpicked for your loved ones</p>
            </div>
            <Link 
              to="/shop" 
              className="text-pink-600 hover:text-pink-700 font-medium text-sm"
            >
              View All →
            </Link>
          </div>
          
          {featuredProducts.length > 0 ? (
            <div className="relative">
              {/* Mobile & Desktop: Horizontal scroll with 2 cards visible */}
              <div className="flex overflow-x-auto pb-3 -mx-4 px-4 scrollbar-hide" ref={productScrollRef}>
                <div className="flex space-x-3 min-w-max">
                  {featuredProducts.map(product => (
                    <div 
                      key={product.id} 
                      className="w-[calc(50vw-32px)] sm:w-56 flex-shrink-0"
                    >
                      <ProductCard product={product} type="product" compact={true} />
                    </div>
                  ))}
                </div>
              </div>
              
              {/* Scroll buttons for desktop */}
              <div className="hidden sm:flex justify-between items-center -mt-20 px-2 pointer-events-none">
                <button 
                  onClick={() => scrollLeft(productScrollRef)}
                  className="bg-white/80 backdrop-blur-sm rounded-full p-2 shadow-lg pointer-events-auto hover:bg-white"
                >
                  <ChevronLeft className="h-5 w-5 text-gray-700" />
                </button>
                <button 
                  onClick={() => scrollRight(productScrollRef)}
                  className="bg-white/80 backdrop-blur-sm rounded-full p-2 shadow-lg pointer-events-auto hover:bg-white"
                >
                  <ChevronRight className="h-5 w-5 text-gray-700" />
                </button>
              </div>
            </div>
          ) : (
            <div className="text-center py-6">
              <Flower className="h-10 w-10 text-gray-300 mx-auto mb-2" />
              <p className="text-gray-500 text-sm">No products available</p>
            </div>
          )}
        </div>
      </section>

      {/* Featured Combos - Horizontal Scroll */}
      <section className="py-8 bg-gradient-to-b from-white to-pink-50">
        <div className="container mx-auto px-4">
          <div className="flex justify-between items-center mb-4">
            <div>
              <div className="inline-flex items-center px-2 py-1 rounded-full bg-gradient-to-r from-pink-100 to-red-100 mb-1">
                <Gift className="h-3 w-3 mr-1 text-pink-600" />
                <span className="text-xs font-bold text-pink-600">Special Offers</span>
              </div>
              <h2 className="text-lg sm:text-xl font-bold text-gray-900">Gift Combos</h2>
              <p className="text-xs text-gray-600">Perfect combinations for special moments</p>
            </div>
            <Link 
              to="/shop?type=combo" 
              className="text-pink-600 hover:text-pink-700 font-medium text-sm"
            >
              View All →
            </Link>
          </div>
          
          {featuredCombos.length > 0 ? (
            <div className="relative">
              {/* Mobile & Desktop: Horizontal scroll with 2 cards visible */}
              <div className="flex overflow-x-auto pb-3 -mx-4 px-4 scrollbar-hide" ref={comboScrollRef}>
                <div className="flex space-x-3 min-w-max">
                  {featuredCombos.map(combo => (
                    <div 
                      key={combo.id} 
                      className="w-[calc(50vw-32px)] sm:w-56 flex-shrink-0"
                    >
                      <ProductCard product={combo} type="combo" compact={true} />
                    </div>
                  ))}
                </div>
              </div>
              
              {/* Scroll buttons for desktop */}
              <div className="hidden sm:flex justify-between items-center -mt-20 px-2 pointer-events-none">
                <button 
                  onClick={() => scrollLeft(comboScrollRef)}
                  className="bg-white/80 backdrop-blur-sm rounded-full p-2 shadow-lg pointer-events-auto hover:bg-white"
                >
                  <ChevronLeft className="h-5 w-5 text-gray-700" />
                </button>
                <button 
                  onClick={() => scrollRight(comboScrollRef)}
                  className="bg-white/80 backdrop-blur-sm rounded-full p-2 shadow-lg pointer-events-auto hover:bg-white"
                >
                  <ChevronRight className="h-5 w-5 text-gray-700" />
                </button>
              </div>
            </div>
          ) : (
            <div className="text-center py-6">
              <Gift className="h-10 w-10 text-gray-300 mx-auto mb-2" />
              <p className="text-gray-500 text-sm">No combos available</p>
            </div>
          )}
          
          {/* Build Combo CTA */}
          <div className="mt-6 bg-gradient-to-r from-pink-50 to-purple-50 rounded-xl p-4">
            <div className="flex flex-col sm:flex-row items-center justify-between">
              <div>
                <h3 className="text-base font-bold text-gray-900 mb-1">Create Your Own Combo</h3>
                <p className="text-xs text-gray-600 mb-3 sm:mb-0">Save 20% with custom packages</p>
              </div>
              <Link 
                to="/custom-combo" 
                className="inline-flex items-center justify-center bg-pink-600 text-white px-4 py-2 rounded-full font-bold hover:bg-pink-700 transition-colors text-sm"
              >
                <Gift className="mr-1.5 h-4 w-4" />
                Build Combo
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials - Horizontal Scroll */}
      <section className="py-8 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-6">
            <h2 className="text-lg sm:text-xl font-bold text-gray-900 mb-2">What Our Customers Say</h2>
            <p className="text-xs text-gray-600">Trusted by thousands across India</p>
          </div>
          
          {/* Testimonials Horizontal Scroll */}
          <div className="flex overflow-x-auto pb-4 -mx-4 px-4 scrollbar-hide">
            <div className="flex space-x-4 min-w-max">
              {testimonials.map((testimonial) => (
                <div key={testimonial.id} className="w-[calc(80vw-32px)] sm:w-80 flex-shrink-0 bg-gradient-to-br from-white to-gray-50 rounded-xl p-4 shadow-sm border border-gray-100">
                  <div className="flex items-center mb-3">
                    <img 
                      src={testimonial.image} 
                      alt={testimonial.name}
                      className="w-8 h-8 rounded-full object-cover border-2 border-white shadow"
                    />
                    <div className="ml-3">
                      <h3 className="font-bold text-sm text-gray-900">{testimonial.name}</h3>
                      <div className="flex items-center">
                        <MapPinIcon className="h-3 w-3 text-gray-400 mr-1" />
                        <span className="text-gray-600 text-xs">{testimonial.location}</span>
                      </div>
                    </div>
                  </div>
                  
                  <div className="mb-3">
                    <div className="flex items-center mb-1">
                      {[...Array(5)].map((_, i) => (
                        <Star 
                          key={i}
                          className={`h-3 w-3 ${i < testimonial.rating ? 'text-yellow-400 fill-yellow-400' : 'text-gray-300'}`}
                        />
                      ))}
                    </div>
                    <div className="inline-flex items-center px-2 py-0.5 rounded-full bg-pink-100 text-pink-600 text-xs font-medium">
                      {testimonial.occasion}
                    </div>
                  </div>
                  
                  <p className="text-gray-700 text-sm italic">"{testimonial.comment}"</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Stats Section - Compact Grid */}
      <section className="py-8 bg-gradient-to-r from-pink-50 to-purple-50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-6">
            <h2 className="text-lg sm:text-xl font-bold text-gray-900 mb-2">Our Numbers</h2>
          </div>
          
          <div className="grid grid-cols-2 gap-3">
            {stats.map((stat, index) => {
              const Icon = stat.icon;
              return (
                <div key={index} className="bg-white p-4 rounded-xl shadow-sm text-center">
                  <div className={`inline-flex items-center justify-center w-12 h-12 rounded-full ${stat.bgColor} ${stat.color} mb-2`}>
                    <Icon className="h-5 w-5" />
                  </div>
                  <div className="font-bold text-lg mb-1">{stat.number}</div>
                  <div className="text-xs text-gray-600">{stat.label}</div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* How It Works - Grid */}
      <section className="py-8 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-6">
            <h2 className="text-lg sm:text-xl font-bold text-gray-900 mb-2">How It Works</h2>
            <p className="text-xs text-gray-600">Simple steps to spread happiness</p>
          </div>
          
          <div className="grid grid-cols-2 gap-3">
            <div className="bg-pink-50 p-4 rounded-xl">
              <div className="w-8 h-8 rounded-full bg-pink-100 text-pink-600 flex items-center justify-center mb-3">
                <span className="font-bold text-sm">1</span>
              </div>
              <h3 className="text-sm font-bold mb-1">Browse & Select</h3>
              <p className="text-xs text-gray-600">Choose from our collection</p>
            </div>
            
            <div className="bg-purple-50 p-4 rounded-xl">
              <div className="w-8 h-8 rounded-full bg-purple-100 text-purple-600 flex items-center justify-center mb-3">
                <span className="font-bold text-sm">2</span>
              </div>
              <h3 className="text-sm font-bold mb-1">Customize Order</h3>
              <p className="text-xs text-gray-600">Add personal touch</p>
            </div>
            
            <div className="bg-blue-50 p-4 rounded-xl">
              <div className="w-8 h-8 rounded-full bg-blue-100 text-blue-600 flex items-center justify-center mb-3">
                <span className="font-bold text-sm">3</span>
              </div>
              <h3 className="text-sm font-bold mb-1">Secure Checkout</h3>
              <p className="text-xs text-gray-600">Safe payment options</p>
            </div>
            
            <div className="bg-green-50 p-4 rounded-xl">
              <div className="w-8 h-8 rounded-full bg-green-100 text-green-600 flex items-center justify-center mb-3">
                <span className="font-bold text-sm">4</span>
              </div>
              <h3 className="text-sm font-bold mb-1">Fresh Delivery</h3>
              <p className="text-xs text-gray-600">Hand-delivered with care</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-8 bg-gradient-to-r from-pink-600 to-purple-600 text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-lg sm:text-xl font-bold mb-3">Ready to Spread Joy?</h2>
          <p className="text-sm mb-6 text-pink-100 max-w-md mx-auto">
            Order now and create unforgettable moments
          </p>
          
          <div className="flex flex-col sm:flex-row gap-3 justify-center mb-6">
            <Link 
              to="/shop" 
              className="inline-flex items-center justify-center bg-white text-pink-700 px-6 py-3 rounded-full font-bold text-sm hover:bg-pink-50 transition-all"
            >
              <ShoppingBag className="mr-2 h-4 w-4" />
              Start Shopping
            </Link>
            
            <Link 
              to="/contact" 
              className="inline-flex items-center justify-center border-2 border-white text-white px-6 py-3 rounded-full font-bold text-sm hover:bg-white/10 transition-all"
            >
              <Phone className="mr-2 h-4 w-4" />
              Need Help?
            </Link>
          </div>
          
          <div className="text-xs text-pink-200">
            Same-day delivery • Free gift wrapping • 100% fresh guarantee
          </div>
        </div>
      </section>

      {/* Newsletter & Social */}
      <section className="py-8 bg-white">
        <div className="container mx-auto px-4">
          <div className="bg-gradient-to-br from-pink-50 to-purple-50 rounded-xl p-4">
            <h3 className="text-lg font-bold mb-3 text-center">Stay Connected</h3>
            
            <div className="grid grid-cols-2 gap-4">
              <div>
                <p className="text-sm text-gray-600 mb-3">Get updates on offers</p>
                <form className="space-y-2">
                  <input 
                    type="email" 
                    placeholder="Your email" 
                    className="w-full px-3 py-2 rounded-full border border-gray-300 focus:outline-none focus:border-pink-500 text-sm"
                  />
                  <button 
                    type="submit"
                    className="w-full bg-pink-600 text-white px-4 py-2 rounded-full font-bold hover:bg-pink-700 transition-colors text-sm"
                  >
                    Subscribe
                  </button>
                </form>
              </div>
              
              <div>
                <p className="text-sm text-gray-600 mb-3">Follow us</p>
                <div className="grid grid-cols-3 gap-2">
                  <a href="#" className="bg-white p-2 rounded-lg text-center hover:shadow transition-shadow">
                    <Instagram className="h-5 w-5 text-pink-600 mx-auto" />
                  </a>
                  <a href="#" className="bg-white p-2 rounded-lg text-center hover:shadow transition-shadow">
                    <Facebook className="h-5 w-5 text-blue-600 mx-auto" />
                  </a>
                  <a href="#" className="bg-white p-2 rounded-lg text-center hover:shadow transition-shadow">
                    <Twitter className="h-5 w-5 text-blue-400 mx-auto" />
                  </a>
                </div>
              </div>
            </div>
            
            <div className="text-center mt-4 pt-4 border-t border-gray-200">
              <div className="text-xs text-gray-500 mb-1">Tag us in your photos</div>
              <div className="font-bold text-sm text-gray-900">#SohkinFlowers</div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;